import {
    Button,
    Paper,
    Grid,
    TextField,
    Select,
    Checkbox,
    FormGroup,
    FormControlLabel,
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem,
    Typography,
    Tab,
    Tabs,
    Card,
    CardHeader,
    CardContent,
    Hidden,
    Chip,
  } from "@material-ui/core";
  import * as React from "react";
  import { observable, action, computed, toJS, autorun } from "mobx";
  import { createStyles, withStyles } from "@material-ui/core/styles";
  import { authStore } from "src/modules/auth";
  import { observer } from "mobx-react";
  import { Loading } from "src/components/loading";
  import { history } from "src/history.js";
  import { withRouter } from "react-router";
  import { validationsStore } from "../../../../validations";
  import { companiesAdminStore } from "..";

  const styles = createStyles({
    root: {
      width: "100%",
      height: "100%",
      margin: "0 auto",
      // padding: "1.5rem",
      padding: "5px",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
    },
    rowContainer: {
      width: "100%",
      display: "flex",
      alignContent: "center",
      margin: "0 auto",
      // padding: "3rem",
    },
    columnContainer: {
      width: "100%",
      display: "flex",
      margin: "0 auto",
      // padding: "3rem",
    },
    textField: {
      display: "flex",
      paddingRight: "24px",
    },
    roleSelect: {
      minWidth: "9rem",
    },
    companySelect: {
      minWidth: "16.5rem",
    },
    appRoleSelect: {
      minWidth: "16.5rem",
      paddingTop: "1.5rem",
    },
    formContainer: {
      width: "100%",
      padding: "1.5rem",
    },
    submitContainer: {
      width: "100%",
      display: "flex",
      flexDirection: "row-reverse",
    },
    submitButton: {
      backgroundColor: "#2A2A55",
      border: "1px solid #2D4D73",
      color: "#FAFAFA",
    },
    tabRoot: {
      height: "100%",
    },
  });

  // C-108
// const PurpleSwitch = withStyles({
//   switchBase: {
//       // color: 'green',
//       '&$checked': {
//           color: '#3D9970',
//       },
//       '&$bar': {
//           color: '#7FDBFF',
//       },
//   },
//   checked: {},
// })(Switch);

  @observer
  class CompanyRelations extends React.Component<any> {
    constructor(props: any) {
      super(props);
    }

    @action
    public addSite =
      () => (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const addedSite = companiesAdminStore.all_sites.find(
          (site: any) => site.site_id === e.target.value
        );
        addedSite.company_id = this.props.currentCompany.company_id;
        this.props.currentCompany.CompanySiteList.push({
          ...addedSite,
          new: true,
        });
        companiesAdminStore.all_sites.find(
          (site: any) => site.site_id === e.target.value
        ).company_id = this.props.currentCompany.company_id;
      };

    @action
    public dropSite = (site_id: number) => {
      this.props.currentCompany.CompanySiteList =
        this.props.currentCompany.CompanySiteList.filter(
          (s: any) => s.site_id !== site_id
        );
      companiesAdminStore.all_sites.find(
        (site: any) => site.site_id === site_id
      ).company_id = null;
    };

    public getSiteChipInfo = (site_id: number) => {
      const site = companiesAdminStore.all_sites.filter(
        (s: any) => s.site_id === site_id
      )[0];
      if (!site) {
        return "none";
      }
      return <React.Fragment>{site.displayName}</React.Fragment>;
    };

    public render() {
      const { classes, mode, currentCompany } = this.props;
      if (!this.props.currentCompany) {
        return <Loading />;
      } else {
        return (
          <div className={classes.root}>
            <Grid container={true} spacing={8}>
              <Grid item={true} xs={6}>
                <Typography variant="h4">Pharmacies</Typography>
                <Select
                  inputProps={{ name: "user_role", id: "user_role" }}
                  value={0}
                  classes={{ root: classes.roleSelect }}
                  // tslint:disable-next-line: jsx-no-lambda
                  onChange={this.addSite()}
                  disabled={this.props.match.params.view_type === "detail"}
                >
               {!this.props.currentCompany.CompanyBusinessType? (companiesAdminStore.all_sites?.filter((site: any) => !site.company_id && !currentCompany.CompanySiteList.map((s: any) => s.site_id).find((s_id: number) => s_id === site.site_id))
                      .map((site: any, index: number) => {
                          return (
                              <MenuItem key={index} value={site.site_id}>
                                  {site.displayName}
                              </MenuItem>
                          );
                  })): ''}
                  {/* D-011 2.0 */}
                </Select>

                {currentCompany.CompanySiteList.reverse().map((site: any) => {
                  if (this.props.match.params.view_type === "detail") {
                    return (
                      <div key={site.site_id}>
                        <Chip
                          style={{ marginTop: "3px" }}
                          label={this.getSiteChipInfo(site.site_id)}
                          className={classes.chip}
                        />
                      </div>
                    );
                  }
                  // tslint:disable-next-line: jsx-no-lambda
                  return (
                    <div key={site.site_id}>
                      <Chip
                        style={{ marginTop: "3px" }}
                        label={this.getSiteChipInfo(site.site_id)}
                        className={classes.chip}
                        onDelete={() => this.dropSite(site.site_id)}
                      />
                    </div>
                  );
                })}
              </Grid>

              {/* D-023 E-053.1 */}
            {/* <Grid item={true} xs={6}>
              <Typography variant="h5">Approval Email</Typography>
                <TextField
                  label="Order Approval Email"
                  classes={{ root: classes.textField }}
                  value={this.props.currentCompany.CompanyApprovalOrderEmail}
                  InputLabelProps={{ shrink: true }}
                  // required={true}
                  onChange={this.handleInput("CompanyApprovalOrderEmail")}
                  error={!validationsStore.validator["CompanyApprovalOrderEmail"].valid && this.props.currentCompany.CompanyApprovalOrderEmail}
                  helperText={
                      (!validationsStore.validator["CompanyApprovalOrderEmail"].valid && this.props.currentCompany.CompanyApprovalOrderEmail)
                          ? validationsStore.validator["CompanyApprovalOrderEmail"].errorMessage.join()
                          : " "
                  }
                  disabled={this.props.match.params.view_type === "detail"}
                />
              {/* C-108 */}
              {/* <div className={classes.toggleBtn}>
                <span>Skip e-sign required to dispense</span>
                <PurpleSwitch
                  checked={this.props.currentCompany.allowUsersForEsign === 1}
                  // tslint:disable-next-line: jsx-no-lambda
                  onChange={() => this.toggleAllowEsing()}
                  // value='blah'
                  color="secondary"
                  inputProps={{ "aria-label": "primary checkbox" }}
                />
              </div>
             </Grid> 
             */} 
              <Grid item={true} xs={6}></Grid>
              <Grid item={true} xs={6} />
            </Grid>
          </div>
        );
      }
    }
    // // D-023 
    // @action
    // protected handleInput = (property: string) => (
    //     e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
    // ) => {
    //     this.props.currentCompany[property] = e.target.value;
    //     validationsStore.runValidator(property, this.props.currentCompany[property] = e.target.value)
    // };
    // @action // C-108
    // public toggleAllowEsing = () => {
    //   const val = this.props.currentCompany.allowUsersForEsign === 0 ? 1 : 0;
    //   this.props.currentCompany.allowUsersForEsign = val;
    // }
  }

  export default withStyles(styles, { withTheme: true })(
    withRouter(CompanyRelations)
  );



// WEBPACK FOOTER //
// ./src/modules/admin/modules/CompaniesAdmin/components/CompanyRelations.tsx